module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop@3x-3da8261e1c1df3e944c89d913a0f31c5.jpg";